import {environment} from "../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const JobsiteApiResources = {
  list:  createUrl('jobsites'), 
  search:  createUrl('jobsites/search'),
  create:  createUrl('jobsites/create'),
  detail:  createUrl('jobsites'),
  update:  createUrl('jobsites'),
  updateStatus:  createUrl('jobsites/update-status'),
  delete:  createUrl('jobsites'),
  deleteMultiple:  createUrl('jobsites/delete/multiple'),
  deleteAvailability:  createUrl('jobsites/delete/availability'),
  types:  createUrl('jobsites/contact-types'),
  jobsiteSummary: createUrl('jobsites/jobsite-summary'),
};
